import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/login/index.tsx");
